module.exports = __webpack_public_path__ + "static/img/6.62af72c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer4/6.png
// module id = //tK
// module chunks = 0